import axios from 'axios'
const endpoint = 'authorization'

export default class AuthorizationService {
  route(params) {
    return axios.get(`/api/${endpoint}/route`, params).then(res => res.data)
  }
}
